
import { useTopManagerPeriods } from './top-manager-period.hook';
import { Typography } from '@mui/material';
import { PeriodPicker } from 'entities/period-picker/period-picker';
import { useActionCreators, useStateSelector } from 'shared/store';
import { ErrorBanner } from 'shared/ui/error-banner';
import { setPeriodActions } from './top-manager-period.slice';

export function TopManangerPeriodPicker() {
  const selectedPeriod = useStateSelector((state) => state.topManagerSelectedPeriod.value);
  const { topManagerPeriods, isLoading, error } = useTopManagerPeriods();
  const { setPeriod } = useActionCreators(setPeriodActions);

  if (error) {
    return <ErrorBanner errorMessage={error} />;
  }

  return (
    <>
      <Typography variant="subtitle1" sx={{ my: 1 }}>Период закрытия</Typography>
      <PeriodPicker
        isLoading={isLoading}
        onSelect={setPeriod}
        periods={topManagerPeriods}
        withAllYearOption
        selectedPeriod={selectedPeriod} />
    </>
  );
}
